module.exports = __webpack_public_path__ + "static/img/cp1-DmBHZhvM.4434d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/cp1-DmBHZhvM.png
// module id = WPYZ
// module chunks = 16